import { SubMenuItemOptions, SimpleMenuItemOptions } from '../types';

export const hasSubMenuItems = (
  item: SimpleMenuItemOptions | SubMenuItemOptions,
): item is SubMenuItemOptions => {
  if (item.hasOwnProperty('subItems')) {
    return true;
  }
  return false;
};
